import { render, staticRenderFns } from "./manageTemplate.vue?vue&type=template&id=f6886a50&scoped=true"
import script from "./manageTemplate.vue?vue&type=script&lang=js"
export * from "./manageTemplate.vue?vue&type=script&lang=js"
import style0 from "./manageTemplate.vue?vue&type=style&index=0&id=f6886a50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6886a50",
  null
  
)

export default component.exports